import type {
  RorosDomainDTO,
  RorosDomainSettingsDTO,
  UpdateDomainSettingsPayload,
} from '@/types/roros/domains';
import { fetchJson, mutate } from './base-roros.service';

// ─── Domains ────────────────────────────────────────────────────────────────

export const RorosDomainService = {
  list: () =>
    fetchJson<RorosDomainDTO[]>('/api/v1/domains'),
  get: (domainId: string) =>
    fetchJson<RorosDomainDTO>(`/api/v1/domains/${domainId}`),
  activate: (domainId: string) =>
    mutate(`/api/v1/domains/${domainId}/activate`, 'PUT'),
  deactivate: (domainId: string) =>
    mutate(`/api/v1/domains/${domainId}/deactivate`, 'PUT'),
  getSettings: (domainId: string) =>
    fetchJson<RorosDomainSettingsDTO>(`/api/v1/domains/${domainId}/settings`),
  updateSettings: (domainId: string, payload: UpdateDomainSettingsPayload) =>
    mutate<RorosDomainSettingsDTO>(`/api/v1/domains/${domainId}/settings`, 'PUT', payload),
  /** M-Rhythm-1: set or clear the accountable actor for a domain. Pass null to clear. */
  setAccountable: (domainId: string, actorId: string | null) =>
    mutate<RorosDomainDTO>(`/api/v1/domains/${domainId}/accountable`, 'PUT', { actor_id: actorId }),
};
